import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbbreviationPipe } from './abbreviation/abbreviation.pipe';
import { ObjectFilterPipe } from './object-filter/object-filter.pipe';
import { PascalCasePipe } from './pascal-case/pascal-case.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AbbreviationPipe,
        ObjectFilterPipe,
        PascalCasePipe,
    ],
    exports: [
        AbbreviationPipe,
        ObjectFilterPipe,
        PascalCasePipe,
    ],
})
export class CaslinkCommonPipesModule {
}
